import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/20/solid";

const SearchBar = ({ value, onChange, isLoading = false, placeholder = "Search clients..." }) => {
  const handleInputChange = (e) => {
    onChange(e.target.value);
  };

  const showClear = value && value.length > 0;

  return (
    <div className="mb-4 w-full max-w-md">
      <div className="relative">
        <input
          type="text"
          name="search"
          value={value}
          onChange={handleInputChange}
          placeholder={placeholder}
          aria-label={placeholder}
          className="block w-full rounded-pill border border-ink-200 bg-white pl-10 pr-10 py-2 text-sm text-ink-900 placeholder:text-ink-400 focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20 focus:outline-none transition-colors"
        />
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          {isLoading ? (
            <div className="h-4 w-4 animate-spin rounded-full border-2 border-ink-200 border-t-accent-500" />
          ) : (
            <MagnifyingGlassIcon
              className="h-4 w-4 text-ink-400"
              aria-hidden="true"
            />
          )}
        </div>
        {showClear && (
          <button
            type="button"
            onClick={() => onChange("")}
            aria-label="Clear search"
            className="absolute inset-y-0 right-0 flex items-center pr-3 text-ink-400 hover:text-ink-600 transition-colors focus:outline-none focus:ring-2 focus:ring-accent-500/20 rounded-pill"
          >
            <XMarkIcon className="h-4 w-4" aria-hidden="true" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
